import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "pb-8 lg:py-6 px-4 md:px-0 sm:pt-10 sf-scope",
  style: {"min-height":"40rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "font-inter"
}
const _hoisted_3 = { class: "text-secondary font-semibold" }
const _hoisted_4 = {
  key: 0,
  class: "sm:pb-14 sm:mb-14"
}
const _hoisted_5 = {
  key: 0,
  class: "pb-10"
}
const _hoisted_6 = { class: "sf-heading sf-category-title text-2xl font-bold pb-6" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col justify-center items-center sm:pt-14 m-auto",
  style: {"padding-bottom":"13.2rem"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "202",
  height: "116",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0247006 7.87823C0.162935 9.46532 0.887052 10.9532 2.06688 12.0735C3.24671 13.1938 4.80475 13.8732 6.46033 13.9891C8.11592 14.1051 9.76012 13.6501 11.0972 12.7061L14.2375 15.7092C14.4312 15.8952 14.6938 15.9996 14.9677 15.9996C15.2415 15.9996 15.5043 15.8953 15.6978 15.7093C15.8915 15.5235 16.0002 15.2714 16 15.0085C16.0002 14.7458 15.8915 14.4937 15.698 14.3078L12.5681 11.2947C13.9283 9.5308 14.2998 7.23853 13.5616 5.1613C12.8236 3.08439 11.0702 1.48725 8.86994 0.888013C6.66989 0.288729 4.30337 0.763496 2.53789 2.15874C0.772543 3.55382 -0.16685 5.69131 0.0244658 7.87791L0.0247006 7.87823ZM6.96867 2.62946C8.26895 2.62946 9.51591 3.12511 10.4353 4.00726C11.3547 4.88941 11.8713 6.08607 11.8713 7.33363C11.8713 8.58119 11.3547 9.77768 10.4353 10.6598C9.51591 11.542 8.2689 12.0376 6.96867 12.0376C5.66844 12.0376 4.42124 11.542 3.50184 10.6598C2.58245 9.77768 2.06587 8.58119 2.06587 7.33363C2.06587 6.08607 2.58245 4.88941 3.50184 4.00726C4.42124 3.12511 5.66844 2.62946 6.96867 2.62946Z",
    fill: "#676767"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "font-medium text-lg pt-2" }, "Nenhum resultado foi encontrado", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-center" }, "Verifique a busca e tente novamente", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

import { computed, onMounted, ref} from 'vue'
import { categories, isLoading } from '@/global/state/GlobalState'
import StoreProductGrid from '@/components/storefront/StoreProductGrid.vue'
import { ProductModel } from '@/models/ProductModel'
import ProductModal from '@/components/modal/ProductModal.vue'
import { searchRegex } from '@/global/state/SearchState';
import { useCategory } from '@/composables/useCategory'

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsIndex',
  props: {
  search: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props

const isProductModalOpen = ref<boolean>(false)
const selectedProduct = ref<any>({})

const totalProducts = computed(() => categories.value?.reduce((acc: number, category: any) => (category.products?.filter((pr: ProductModel) => searchRegex.value.test(pr.name)).length || 0) + acc, 0))

onMounted(() => {
    searchRegex.value = new RegExp(`.*${props.search}.*`, 'i')
    if(!categories.value){
      isLoading.value = true
      const { listCategories, categories: categoryList } = useCategory()
      
      listCategories({ perPage: 100 }).then(() => {
          categories.value = categoryList.value
          isLoading.value = false
      }).catch(err => console.error(err))
    }
  })
const setModalProduct = (product: ProductModel) => {
  selectedProduct.value = product
  isProductModalOpen.value = !isProductModalOpen.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.search)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_2, [
            _createElementVNode("strong", null, _toDisplayString(totalProducts.value) + " resultado(s)", 1),
            _createTextVNode(" para "),
            _createElementVNode("span", _hoisted_3, "\"" + _toDisplayString(__props.search) + "\"", 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col", __props.search ? 'pt-8':''])
      }, [
        (_unref(categories)?.length && _unref(categories)?.some((category) => category.products.length && category.products.some((p) => _unref(searchRegex).test(p.name))))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.id
                }, [
                  (category.products.length && category.products.some((p) => _unref(searchRegex).test(p.name)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("h5", _hoisted_6, _toDisplayString(category.name), 1),
                        _createVNode(StoreProductGrid, {
                          products: category.products.filter((p) => _unref(searchRegex).test(p.name)),
                          onSelect: setModalProduct
                        }, null, 8, ["products"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
      ], 2)
    ]),
    _createVNode(ProductModal, {
      isOpen: isProductModalOpen.value,
      setSelectedProductVariations: (product) => selectedProduct.value.variations = product,
      toggleModal: (value) => isProductModalOpen.value = value,
      selectedProduct: selectedProduct.value,
      setSelectedProduct: (product) => selectedProduct.value = product
    }, null, 8, ["isOpen", "setSelectedProductVariations", "toggleModal", "selectedProduct", "setSelectedProduct"])
  ], 64))
}
}

})